import Card from '@mui/material/Card';
import axios from 'src/utils/axios';
import { useLocation } from 'react-router';
import { useParams, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Backdrop, CircularProgress, Snackbar, IconButton, Grid, Typography, Button, Box, Divider, CardHeader, CardContent } from '@mui/material';
import Alert from 'src/components/Alert';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import moment from 'moment';

function WarrantyTypeDetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const { WarrantyType, WarrantyDesc } = useParams();
  const [warrantyTypeInclude, setWarrantyTypeInclude] = useState([]);
  const [warrantyTypeExclude, setWarrantyTypeExclude] = useState([]);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [loading, setLoading] = React.useState(false);
  const [selectedRowsExclude, setSelectedRowsExclude] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  const columns = [
    { field: 'kul_garanti_tipi', headerName: 'Garanti Tipi', width: 200 },
    { field: 'aciklama', headerName: 'Açıklama', width: 250 },
    { field: 'adsoyad', headerName: 'Kullanıcı', width: 150 },
    {
      field: 'tarih',
      headerName: 'Tarih',
      width: 150,
      renderCell: params => {
        // params.value tarihin string formatını veya Date objesini içerir
        return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
      }
    }
  ];

  const columnsExclude = [
    { field: 'kul_garanti_tipi', headerName: 'Garanti Tipi', width: 200 },
    { field: 'aciklama', headerName: 'Açıklama', width: 250 },
    { field: 'adsoyad', headerName: 'Kullanıcı', width: 150 },
    { field: 'tarih', headerName: 'Tarih', width: 150 },
    {
      field: 'tarih',
      headerName: 'Tarih',
      width: 150,
      renderCell: params => {
        // params.value tarihin string formatını veya Date objesini içerir
        return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
      }
    }
  ];

  useEffect(() => {
    handleGetSarisDynamicWarrantyTypeInclude();
    handleGetSarisDynamicWarrantyTypeExclude();
  }, []);

  const handleGetSarisDynamicWarrantyTypeInclude = () => {
    setLoading(true);
    axios
      .get(`SetSarisDynamicWarrantyTypeInclude/${WarrantyType}`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        setWarrantyTypeInclude(Array.isArray(data) ? data : []);
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const handleGetSarisDynamicWarrantyTypeExclude = () => {
    setLoading(true);
    axios
      .get(`SetSarisDynamicWarrantyTypeExclude/${WarrantyType}`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        setWarrantyTypeExclude(Array.isArray(data) ? data : []);
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const handleGetSarisDynamiNewcWarrantyTypeInclude = selectedIncludeDataList => {
    setLoading(true);
    axios
      .get(
        `SetSarisDynamicIncludeNewWarranty/${WarrantyType}/${selectedIncludeDataList}`
      )
      .then(response => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          handleGetSarisDynamicWarrantyTypeInclude();
          handleGetSarisDynamicWarrantyTypeExclude();
          handleClearSelection();
          return;
        } else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          handleGetSarisDynamicWarrantyTypeInclude();
          handleGetSarisDynamicWarrantyTypeExclude();
          handleClearSelection();
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const handleGetSarisDynamicNewWarrantyTypeExclude = selectedIncludeDataList => {
    setLoading(true);
    axios
      .get(
        `SetSarisDynamicExcludeNewWarranty/${WarrantyType}/${selectedIncludeDataList}`
      )
      .then(response => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          handleClearSelection();
          return;
        } else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          handleGetSarisDynamicWarrantyTypeInclude();
          handleGetSarisDynamicWarrantyTypeExclude();
          handleClearSelection();
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const handleGoBack = () => {
    const fullPath = location.pathname;
    const basePath = fullPath
      .split('/')
      .slice(0, 2)
      .join('/');
    // Detay sayfasından dönüldüğünü belirtmek için previousPath'i güncelliyoruz.
    localStorage.setItem('previousPath', basePath || '/');
    navigate(-1); // Geri gitmek için useNavigate hook'unu kullanıyoruz.
  };
  const handleClearSelection = () => {
    setSelectedRows([]);
    setSelectedRowsExclude([]);
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={5000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        />
      </Snackbar>
      <Backdrop sx={(theme) => ({ zIndex: theme.zIndex.drawer + 1, color: '#fff' })} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card>
        <CardHeader
          avatar={
            <IconButton onClick={() => { handleGoBack(); }}>
              <ArrowBackIcon />
            </IconButton>
          }
          title={
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
              {WarrantyDesc}
            </Typography>
          }
        />
        <Divider />
        <CardContent>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                Kapsam Dışında Bırakılabilecekler
              </Typography>
              <Box sx={{ height: 350, width: '100%' }}>
                <DataGrid
                  sx={{
                    '& .MuiDataGrid-columnHeaderTitle': {
                      fontWeight: 700,
                      color: 'text.primary'
                    },
                    '& .MuiDataGrid-cell': {
                      color: 'text.primary'
                    }
                  }}
                  rows={warrantyTypeInclude}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: { page: 0, pageSize: 0 }
                    }
                  }}
                  slots={{
                    pagination: () => null, // Pagination bileşenini kaldırma
                    toolbar: GridToolbar
                  }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                      quickFilterProps: { placeholder: 'Ara...' }
                    }
                  }}
                  getRowId={rows => rows.alt_garanti_tipi}
                  pageSizeOptions={[5, 10]}
                  checkboxSelection
                  onSelectionModelChange={newSelection =>
                    setSelectedRowsExclude(newSelection)
                  }
                  selectionModel={selectedRowsExclude}
                />
              </Box>
              <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<DeleteIcon />}
                  onClick={() => {
                    handleGetSarisDynamicNewWarrantyTypeExclude(
                      selectedRowsExclude
                    );
                  }}
                >
                  Seçili Olanı Sil
                </Button>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
                Kapsam Dışında Bırakılanlar
              </Typography>
              <Box sx={{ height: 700, width: '100%' }}>
                <DataGrid
                  sx={{
                    '& .MuiDataGrid-columnHeaderTitle': {
                      fontWeight: 700,
                      color: 'text.primary'
                    },
                    '& .MuiDataGrid-cell': {
                      color: 'text.primary'
                    }
                  }}
                  rows={warrantyTypeExclude}
                  columns={columnsExclude}
                  initialState={{
                    pagination: {
                      paginationModel: { page: 0, pageSize: 5 }
                    }
                  }}
                  slots={{
                    pagination: () => null, // Pagination bileşenini kaldırma
                    toolbar: GridToolbar
                  }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                      quickFilterProps: { placeholder: 'Ara...' }
                    }
                  }}
                  getRowId={rows => rows.garanti_tipi}
                  pageSizeOptions={[5, 10]}
                  checkboxSelection
                  onSelectionModelChange={newSelection =>
                    setSelectedRows(newSelection)
                  }
                  selectionModel={selectedRows}
                />
              </Box>
              <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    handleGetSarisDynamiNewcWarrantyTypeInclude(selectedRows);
                  }}
                >
                  Seçili Olanı Ekle
                </Button>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}

export default WarrantyTypeDetail;
